export const productsSpecialField = [
  {
    code:'eer',
    nameEn:'Energy Efficiency Ratio (EER)',
    nameTh:'ประสิทธิภาพเครื่องปรับอากาศ',
    type:'int',
    condition:'>11'
  },
  {
    code:'r',
    nameEn:'Refrigerants',
    nameTh:'สารทำความเย็น/ น้ำยาแอร์',
    type:'string',
    condition:'134a,410a,32'
  }
]

export function productJson() {return{
  CoverImgName: '',
  CoverImgURL: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
  AttIMG:[ 
    {
      ID: 1,
      ProductID: 0,
      Filename: 'pp',
      OriginaFilename: 'pp.jpg',
      Size: 0,
      Filetype: '',
      DocumentType: '10',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    },
    {
      ID: 2,
      ProductID: 0,
      Filename: '',
      OriginaFilename: '',
      Size: 0,
      Filetype: '',
      DocumentType: '10',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    },
    {
      ID: 3,
      ProductID: 0,
      Filename: '',
      OriginaFilename: '',
      Size: 0,
      Filetype: '',
      DocumentType: '10',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    }
  ],
  AttVDO: [
    {
      ID: 1,
      ProductID: 0,
      Filename: '',
      OriginaFilename: '',
      Size: 0,
      Filetype: '',
      DocumentType: 11,
      FileStream:null,
      UrlPath: 'https://www.youtube.com/watch?v=p_dgvgpC8Nw',
      IsDelete:false
    },
    {
      ID: 2,
      ProductID: 0,
      Filename: '',
      OriginaFilename: '',
      Size: 0,
      Filetype: '',
      DocumentType: 11,
      FileStream:null,
      UrlPath: 'https://youtu.be/p_dgvgpC8Nw',
      IsDelete:false
    }
  ],
  AttOther: [
    {
      ID: 1,
      ProductID: 0,
      Filename: 'เอกสารการติดตั้ง',
      OriginaFilename: 'เอกสารการติดตั้ง.jpg',
      Size: 0,
      Filetype: '',
      DocumentType: '12',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    },
    {
      ID: 2,
      ProductID: 0,
      Filename: 'เงื่อนไขการรับประกัน',
      OriginaFilename: 'เงื่อนไขการรับประกัน.jpg',
      Size: 0,
      Filetype: '',
      DocumentType: '12',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    },
    {
      ID: 3,
      ProductID: 0,
      Filename: 'เอกสารตัวอย่างการใช้งาน',
      OriginaFilename: 'เอกสารตัวอย่างการใช้งาน.pdf',
      Size: 0,
      Filetype: '',
      DocumentType: '12',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    },
    {
      ID: 4,
      ProductID: 0,
      Filename: '',
      OriginaFilename: '',
      Size: 0,
      Filetype: '',
      DocumentType: '12',
      FileStream:null,
      UrlPath: 'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
      IsDelete:false
    }
  ],
  MQDCStd:[],
  ProductPrice: 1200,
  ID: 1,
  No: 'U000-C01',
  Name: 'เก้าอี้ Eames',
  Brandname:'Eames',
  Description: 'เก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Greyเก้าอี้ Eames DSW Grey',
  CategoryID: 9,
  CategoryName: 'Furniture',
  SubCategoryID: 8,
  SubCategoryName: 'อุปกรณ์สำนักงาน',
  UnitID: 0,
  UnitName: 'ชิ้น',
  Dimension: '45*45/ H:75',
  GrossWeight: 1.2,
  NetWeight: 1.5,
  WeightUnit: 'kg',
  MinimunOrder: 1,
  PlanDeliveryTime: '7 วันทำการ',
  VendorID: 0,
  Lifetime: '10 ปี',
  Warranty: '1 ปี',
  Remark: 'สิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเองสิ้นค้าต้องประกอบเอง',
  Active: true,
  CreatedDate: '2019-06-19T03:08:46.611Z',
  CreatedBy: 0,
  ModifiedDate: '2019-06-19T03:08:46.611Z',
  ModifiedBy: 0,
  Deleted: false,
  DeletedDate: '',
  DeletedBy: 0}
}
export const productsJson = [
  {
    "ID": 1,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "",
    "DeletedBy": 0
  },
  {
    "ID": 2,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 3,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 4,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 5,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 6,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 7,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 8,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  },
  {
    "ID": 9,
    "No": "U000-C01",
    "Name": "เก้าอี้ Eames",
    "Description": "เก้าอี้ Eames DSW Grey",
    "CategoryID": 0,
    "CategoryName": "CategoryName",
    "SubCategoryID": 0,
    "SubCategoryName": "SubCategoryName",
    "Brandname":'Eames',
    "UnitID": 0,
    "UnitName": "UnitName",
    "Dimension": "Dimension",
    "GrossWeight": 0,
    "NetWeight": 0,
    "WeightUnit": "WeightUnit",
    "MinimunOrder": 0,
    "PlanDeliveryTime": "PlanDeliveryTime",
    "VendorID": 0,
    "Lifetime": "Lifetime",
    "Warranty": "Warranty",
    "Remark": "Remark",
    "Active": true,
    "CoverImgUrl":'https://store.chuno.co.th/public/upload/products/original/Eames-DSW-LGray.jpg',
    "CreatedDate": "2019-06-19T03:08:46.635Z",
    "CreatedBy": 0,
    "ModifiedDate": "2019-06-19T03:08:46.635Z",
    "ModifiedBy": 0,
    "Deleted": false,
    "DeletedDate": "2019-06-19T03:08:46.635Z",
    "DeletedBy": 0
  }
]
export const cateJson = [
  {text: 'All', value: -1},
  { text: 'Constrution Mat', value: 1 },
  { text: 'Nonvaluated Mat', value: 2 },
  { text: 'House/Condo', value: 3 },
  { text: 'Land', value: 4 },
  { text: 'Operating Suppliers', value: 5 },
  { text: 'Services', value: 6 },
  { text: 'Stationery', value: 7 },
  { text: 'Trading Goods', value: 8 },
  { text: 'Furniture', value: 9 }
]
export const subCateJson = [
  { text: 'งานจ้างทั่วไป', value: 1 },
  { text: 'งานจ้างเหมาก่อสร้าง', value: 2 },
  { text: 'งานการตลาด', value: 3 },
  { text: 'งานซ่อมบำรุง', value: 4 },
  { text: 'ค่าเช่า', value: 5 },
  { text: 'ค่าใช้จ่าย', value: 6 },
  { text: 'งานที่ปรึกษา', value: 7 },
  { text: 'อุปกรณ์สำนักงาน', value: 8 },
  { text: 'อุปกรณ์ IT', value: 9 }
]
export const brandndameJson = [
  { text: 'Eames', value: 1 },
  { text: 'SAMSUNG', value: 2 },
  { text: 'Huawei', value: 3 },
  { text: 'LG', value: 4 }
]
export const unitJson = [
  { text: 'm', value: 1 },
  { text: 'kg', value: 2 },
  { text: 'lb', value: 3 },
  { text: 'oz', value: 4 },
  { text: 'g', value: 4 }
]
